import axios from 'axios';

// Relative URL works in production and local dev (via package.json proxy)
const API_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

function getCookie(name) {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  return match ? decodeURIComponent(match[2]) : null;
}

api.interceptors.request.use((config) => {
  const csrfToken = getCookie('csrftoken');
  if (csrfToken) {
    config.headers['X-CSRFToken'] = csrfToken;
  }
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }
  return config;
});

export default api;

export const getMediaUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http')) return path;

  const MEDIA_URL = process.env.REACT_APP_MEDIA_URL || '/media';

  return `${MEDIA_URL}/${path}`;
};
